import styles from './Divider.module.css';

export const Divider = () => {
  return (
    <div className={styles.Divider}>
      <div className={styles.line} />
    </div>
  );
};
